import { Filter, FilterTypes, Segment, ServiceStatus } from "@madhive/mad-sdk";

/**
 * Default segment filters - matches mad-sdk DEFAULT_SEGMENT_FILTERS.
 * Fetches DRAFT, READY, and EXPIRED segments (excludes ARCHIVED).
 *
 * Matches mad-web/packages/core/mad-sdk/src/lib/modules/dataManagementPlatforms/segments/constants.ts
 */
export const DEFAULT_SEGMENT_FILTERS: Filter<Segment> = {
  where: [
    {
      type: FilterTypes.IN,
      value: [ServiceStatus.DRAFT, ServiceStatus.READY, ServiceStatus.EXPIRED],
      field: "status" as keyof Segment
    }
  ]
};

/**
 * Filters for fetching only ARCHIVED segments.
 * Used for background loading after the initial segment fetch completes.
 */
export const ARCHIVED_SEGMENT_FILTERS: Filter<Segment> = {
  where: [
    {
      type: FilterTypes.IN,
      value: [ServiceStatus.ARCHIVED],
      field: "status" as keyof Segment
    }
  ]
};
